"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.populateWithDefault = void 0;
var dayjs_1 = __importDefault(require("dayjs"));
function populateWithDefault(sale, defaultConfig) {
    var _a;
    // TODO: generalize check for enabled/disabled registration
    if (sale.type !== 'referral' &&
        defaultConfig.registration &&
        sale.startDate) {
        var registration = defaultConfig.registration;
        var saleStart = (0, dayjs_1.default)(sale.startDate).utc();
        sale.registerDate = saleStart
            .subtract(registration.startHours, 'hours')
            .toISOString();
        sale.registerDuration = registration.startHours - registration.endHours;
    }
    if ((_a = defaultConfig.fcfs) === null || _a === void 0 ? void 0 : _a.durationHours) {
        sale.fcfsDuration = defaultConfig.fcfs.durationHours;
    }
    return sale;
}
exports.populateWithDefault = populateWithDefault;
